<template>
  <div class="content-container">
    <!-- <a-form-model class="search-form" layout="inline" :model="searchForm">
      <a-form-model-item
        has-feedback
        :label="$t('table.advertisement.thead.name')"
        style="margin-bottom: 0px"
      >
        <a-input
          v-model="searchForm.name"
          :placeholder="$t('table.advertisement.thead.name')"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" html-type="submit" @click="search">{{
          $t(`actionTitles.submit`)
        }}</a-button>
      </a-form-model-item>
      <a-form-model-item layout="vertical">
        <a-button
          type="primary"
          :style="{ margin: '0px 15px' }"
          @click="addAdvertisement"
          >{{$t('actionTitles.add')}}</a-button
        >
      </a-form-model-item>
    </a-form-model> -->

    <div class="table-wrapper">
      <a-button
        type="primary"
        :style="{ margin: '10px 15px' }"
        @click="addRegion"
        >{{ $t("actionTitles.addRegion") }}</a-button
      >
      <div style="padding: 10px" v-show="regionDepthList.length > 0">
        <a-breadcrumb>
          <a-breadcrumb-item>
            <span style="font-weight: bold;color: black;">{{$t('form.region.commonLabel.currentRegion')}}：</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a @click="queryByPid({id: 0})">{{$t('form.region.commonLabel.rootRegion')}}</a>
          </a-breadcrumb-item>
          <a-breadcrumb-item
            v-for="(item, index) in regionDepthList"
            :key="index"
          >
            <a v-if="index < regionDepthList.length - 1" @click="queryByPid(item)">{{ item.name }}</a>
            <span v-else>{{ item.name }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>

      <a-table
        :data-source="pageResult"
        :loading="loading"
        :pagination="pagination"
        rowKey="id"
        @change="handleTableChange"
      >
        <a-table-column
          key="id"
          :title="$t('table.advertisement.thead.id')"
          data-index="id"
          align="center"
        >
        </a-table-column>
        <a-table-column
          key="name"
          :title="$t('form.region.name.label')"
          data-index="name"
          align="center"
        />
        <a-table-column
          key="type"
          :title="$t('form.region.regionLevel.label')"
          data-index="type"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.type }}</span>
          </template>
        </a-table-column>

        
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a @click.stop="followRegionLoad(record)">{{$t('form.region.regionOption.label')}}</a>
              <a-divider type="vertical" />
              <a @click.stop="regionEdit(record)">{{
                $t(`actionTitles.edit`)
              }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => deleteInfo(record.id)"
              >
                <a href="javascript:;" style="color: red">{{
                  $t(`actionTitles.delete`)
                }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :title="modelTitle"
      :visible="exitVisible"
      @ok="saveRegion"
      @cancel="close"
      keyboard
    >
      <a-form-model
        ref="form"
        layout="vertical"
        :model="form"
        :rules="rules"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item
          :label="$t('form.region.name.label')"
          prop="name"
        >
          <a-input
            v-model="form.name"
            :placeholder="$t('form.region.name.placeholder')"
          />
        </a-form-model-item>
        <!-- <a-form-model-item
          :label="$t('form.region.reginID.label')"
          ref="id"
          prop="id"
        >
          <a-input
            :disabled="true"
            v-model="form.id"
          />
        </a-form-model-item> -->
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import {
  delRegion,
  addRegion,
} from "@/api/homeBan";
import { getRegoin } from "@/api/publish";
import DragUploader from "@/components/DragUploader";

export default {
  components: {
    DragUploader,
  },
  data() {
    return {
      // searchForm: {
      //   current_page: 1,
      //   per_page: 10,
      //   name: "",
      //   order: {},
      //   type: [], //0頂部廣告位 1中部廣告位
      // },
      isaddRegion: true,
      regionDepthList: [],
      pageResult: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      modelTitle: "",
      form: {
        url: "",
        name: "",
      },
      exitVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("form.region.name.message"),
            trigger: "blur",
          },
        ],
        id: [
          {
            required: true,
          },
        ],
      },
      uploading: false,
    };
  },
  mounted() {
    this.loadData(0);
  },
  methods: {
    loadData(regionId) {
      this.loading = true;
      getRegoin({ regoin_id: regionId }).then((res) => {
        this.loading = false;
        this.pageResult = res.data;
      }).catch(() => {
        this.loading = false;
      });
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";
        let order = {};
        order[field] = orderStr;
        this.searchParam.order = order;
      }
      const id = this.getCurrentRegionId();
      this.loadData(id);
    },
    followRegionLoad(region) {
      const regionId = region.id;
      this.regionDepthList.push(region);
      console.log("current id==", regionId)
      this.loadData(regionId);
      //分頁重置
      this.resetPagination()
    },
    queryByPid(region) {
      const regionId = region.id;
      if(regionId === 0) {
        this.regionDepthList = [];
      } else {
        //處理麵包屑數據
        this.handleBreadcrumb(region);
      }
      this.loadData(regionId);
      //分頁重置
      this.resetPagination()
    },
    handleBreadcrumb(item) {
      const currIndex = this.regionDepthList.findIndex(el => el.id === item.id)
      if(currIndex > -1) {
        this.regionDepthList = this.regionDepthList.slice(0, currIndex+1);
      }
    },

    handleReset() {
      this.form = { url: "", name: "" };
      this.$refs.form.resetFields();
    },
    resetPagination() {
      this.pagination = {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      };
    },
    addRegion() {
      this.isaddRegion = true;
      this.modelTitle = this.$t("actionTitles.add");
      this.exitVisible = true;
      setTimeout(() => {
        this.handleReset();
      }, 0);
    },
    close() {
      this.exitVisible = false;
      this.$refs.form.resetFields();
    },
    getCurrentRegionId() {
      let pid = 0;
      if(this.regionDepthList.length > 0) {
        const parent_regoin = this.regionDepthList[this.regionDepthList.length - 1];
        pid = parent_regoin.id;
      }
      return pid;
    },
    saveRegion() {
      const pid = this.getCurrentRegionId();
      this.$refs.form.validate((valid) => {
        if (valid) {
          const param = this.isaddRegion ? {
            name: this.form.name, 
            pid
          } : {
            name: this.form.name, 
            pid,
            id: this.form.id
          }
          addRegion(param).then((res) => {
            this.$message.success(this.$t("message.saveSuccess"))
            this.exitVisible = false;
            this.handleReset();
            this.loadData(pid);
          })
        }
      });
    },
    regionEdit(region) {
      this.isaddRegion = false;
      this.modelTitle = this.$t("actionTitles.edit");
      this.form = this.$deepClone(region);
      this.exitVisible = true;
    },
    deleteInfo(id) {
      delRegion({ id: id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              const id = this.getCurrentRegionId();
              this.loadData(id);
            });
          }
        })
        .catch((err) => {});
    },
    
    reset() {
      this.pagination.current = 1;
    },
  },
};
</script>
<style lang="less" scoped>
// .content-container {
//   background-color: #ffffff;
// }
</style>
